import { render, staticRenderFns } from "./AwardRule.vue?vue&type=template&id=11813334&"
import script from "./AwardRule.vue?vue&type=script&lang=js&"
export * from "./AwardRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports